'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { ClientParticipant } from './client-account';

const ParticipantContext = createContext<ClientParticipant | null>(null);

export function ParticipantProvider({
  participant,
  children,
}: {
  /** Only the safe fields: build it with toClientParticipant. */
  participant: ClientParticipant | null;
  children: ReactNode;
}) {
  return (
    <ParticipantContext.Provider value={participant}>
      {children}
    </ParticipantContext.Provider>
  );
}

export function useParticipant() {
  return useContext(ParticipantContext);
}
